export default {"src":"/_next/static/media/MapBlue.0eb65a4f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};